import React from "react";
import { Card, Headline, Paragraph } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import EquifaxLogo from "_assets/logos/equifax.svg";
import "./PullingCredit.scss";

function PullingCredit(props) {
  const { settings } = useSettings();

  return (
    <Card id="pulling-credit">
      <div className="apply-form">
        <div className="equifax-logo">
          <img src={EquifaxLogo} alt="" />
        </div>
        <Headline>Gathering your information...</Headline>
        <div
          className="credit-spinner"
          style={{
            borderTop: `10px solid ${settings?.primary_color || "#0f766e"}`,
          }}
        />
        <Paragraph opacity={0.6}>Retrieving report...</Paragraph>
      </div>
    </Card>
  );
}

export default PullingCredit;
